module.exports = __webpack_public_path__ + "img/hygh.0ad2a7e2.jpg";